import { ArticleScreen } from 'app/features/blog/screens'
import { fetchArticleQuery } from 'app/features/blog/screens/article-screen/queries'
import { addApolloState, initializeApollo } from 'lib/initialize-apollo'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'

export default function Page(props: any) {
  return <ArticleScreen {...props} />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(async ({ req, res, query }) => {
  const user = req?.session?.user
  const draft = !!query?.preview

  const client = initializeApollo({
    token: user?.token,
    previewToken: query?.token as string,
  })

  await client.query({
    query: fetchArticleQuery,
    variables: {
      slug: query.slug as string,
      draft,
    },
  })

  // add cache headers if not authenticated
  if (!user) {
    res.setHeader('Cache-Control', 's-maxage=60, stale-while-revalidate')
  }

  return addApolloState(client, {
    props: {
      user: user || null,
      preview: draft,
    },
  })
})
